const extensions: Record<string, string> = {
  'image/png': 'png', 'image/jpeg': 'jpg', 'image/webp': 'webp', 'image/gif': 'gif',
  'video/mp4': 'mp4', 'video/webm': 'webm', 'video/quicktime': 'mov',
};

/** Save media without navigating to a cross-origin preview. */
export async function downloadMedia(url: string, filename: string, attachmentHref?: string) {
  if (attachmentHref) {
    const attachment = new URL(attachmentHref, window.location.href);
    if (attachment.origin !== new URL(window.location.href).origin) throw new Error('Invalid download endpoint');
    const check = await fetch(attachment.href, { method: 'HEAD', signal: AbortSignal.timeout(30_000) });
    if (check.status !== 409) {
      if (!check.ok || !check.headers.get('content-disposition')?.startsWith('attachment;')) throw new Error('File download unavailable');
      const link = document.createElement('a');
      link.href = attachment.href; link.download = '';
      document.body.appendChild(link);
      try { link.click(); } finally { link.remove(); }
      return;
    }
    // Archival failures can leave a valid provider URL; retain the blob download.
  }
  const response = await fetch(url, { signal: AbortSignal.timeout(120_000) });
  if (!response.ok) throw new Error('Media download failed');
  const blob = await response.blob();
  if (!blob.size) throw new Error('Empty media download');
  const urlExtension = new URL(url, window.location.href).pathname.match(/\.(png|jpe?g|webp|gif|mp4|webm|mov)$/i)?.[1];
  const extension = extensions[blob.type.split(';')[0].toLowerCase()] || urlExtension;
  // A binary blob must be saved rather than handed to an image/video previewer.
  const objectUrl = URL.createObjectURL(new Blob([blob], { type: 'application/octet-stream' }));
  const link = document.createElement('a');
  link.href = objectUrl;
  link.download = extension ? filename.replace(/\.[^.]+$/, '') + '.' + extension : filename;
  document.body.appendChild(link);
  try { link.click(); }
  finally {
    link.remove();
    // Give the browser time to consume the download before releasing its URL.
    setTimeout(() => URL.revokeObjectURL(objectUrl), 60_000);
  }
}
